import { render, staticRenderFns } from "./page-manage.vue?vue&type=template&id=87c31402&scoped=true"
import script from "./page-manage.vue?vue&type=script&lang=js"
export * from "./page-manage.vue?vue&type=script&lang=js"
import style0 from "./page-manage.vue?vue&type=style&index=0&id=87c31402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c31402",
  null
  
)

export default component.exports